// extracted by mini-css-extract-plugin
export default {"content":"Tooltip_content__zocCT"};